import { isBrowser } from '../isBrowser'

export const getUrlParameters = (): URLSearchParams =>
  isBrowser() ? new URLSearchParams(window.location.search) : new URLSearchParams()
